/**
 * `itc04.*` wire contract (Increment 10) — quarterly job-work challan report.
 *
 * Generic compliance (any manufacturer with job-workers), so `tenantedProcedure`.
 * Read-only: the on-screen quarter summary + a CSV download. Money is integer
 * paise serialised as strings.
 */
import { z } from "zod";
import { isoDate } from "../_common.js";

const paise = z.string().regex(/^-?\d+$/);

export const getQuarterInput = z.object({
  fy: z.number().int().min(2017).max(2100),
  quarter: z.number().int().min(1).max(4),
});

const challanRow = z.object({
  vendorName: z.string(),
  vendorGstin: z.string().nullable(),
  docNumber: z.string().nullable(),
  date: isoDate,
  taxablePaise: paise,
  taxPaise: paise,
  totalPaise: paise,
});

export const getQuarterOutput = z.object({
  fy: z.number().int(),
  quarter: z.number().int(),
  periodStart: isoDate,
  periodEnd: isoDate,
  rows: z.array(challanRow),
  jobWorkerCount: z.number().int().nonnegative(),
  challanCount: z.number().int().nonnegative(),
  totalTaxablePaise: paise,
  totalTaxPaise: paise,
  totalPaise: paise,
});

export const exportCsvInput = getQuarterInput;
export const exportCsvOutput = z.object({ fileName: z.string(), csv: z.string() });

export type GetQuarterOutput = z.infer<typeof getQuarterOutput>;
